import { FC } from 'react';
import { DAFConfirmation } from './DAF';
import { StripeConfirmation } from './Stripe';
import { Routes, Route } from 'react-router-dom';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { IPage } from 'store/pages/types';
import { IEvent } from 'store/event/types';
import { StripeElementsProvider } from './Stripe/Provider';

interface Props {
  candidates: CandidateType[];
  donationAmount: number;
  page?: IPage | IEvent;
  isEvent: boolean;
  pageImage: string;
}

export const Confirmation: FC<Props> = ({
  candidates,
  donationAmount,
  isEvent,
  pageImage,
  page,
}) => {
  return (
    <Routes>
      <Route
        path="daf"
        element={
          <DAFConfirmation
            candidates={candidates}
            donationAmount={donationAmount}
            isEvent={isEvent}
            pageImage={pageImage}
          />
        }
      />
      <Route
        path="standard"
        element={
          <StripeElementsProvider>
            <StripeConfirmation
              donationAmount={donationAmount}
              numRecipients={candidates.length}
              page={page}
            />
          </StripeElementsProvider>
        }
      />
    </Routes>
  );
};
